<!-- TODO: переделать props на elem, показывать этот компонент -->
<!-- вместо YoutubeEmbed, VimeoEmbed, TedEmbed. Повесить класс с модификатором -->
<!-- providerNameSlug и вынести стили из вышеупомянутых компонентов -->
<template>
  <div class="base-iframe">
    <iframe
      class="base-iframe__iframe"
      :src="startLoading ? src : ''"
      frameborder="0"
      v-bind="$attrs"
      @load="loaded = true"
    />
    <LazyloadPlaceholder
      v-if="!loaded"
      class="base-iframe__placeholder"
    />
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import LazyloadPlaceholder from '~/components/LazyloadPlaceholder.vue';
  export default defineNuxtComponent({
    name: 'BaseIframe',
    components: {
      LazyloadPlaceholder,
    },

    props: {
      src: {
        type: String as PropType<string>,
        required: true,
      },
    },

    data: () => ({
      loaded: false,
      startLoading: false,
    }),

    mounted() {
      this.startLoading = true;
    },
  });
</script>

<style lang="scss" scoped>
  .base-iframe {
    &__iframe {
      width: 100%;
      height: 100%;
    }

    &__placeholder {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
  }
</style>
